module.exports = __webpack_public_path__ + "img/gift-box.91f9217f.svg";